import * as React from "react";
import logoBigHeardsmallActive from './images/logoBigHeardsmallActive.png';

function SvgBigIcon(props) {
  return (
    <img src={logoBigHeardsmallActive} width={72} height={71} {...props} alt="fireHeard" /> 
  );
}

export default SvgBigIcon